import type { AreaInset } from "../app/platform/Platform";

// Default safe area inset
let safeAreaInset: AreaInset = { top: 0, right: 0, bottom: 0, left: 0 };

let defaultBannerHeight = 0;

export function getSafeAreaInset(): AreaInset {
  return safeAreaInset;
}

export function setSafeAreaInset(inset: AreaInset): void {
  safeAreaInset = inset;
}

export function setDefaultBannerHeight(height: number): void {
  defaultBannerHeight = height;
}
export function getBannerHeight(): number {
  return defaultBannerHeight;
}